import { matches } from '@/mocks/matches';

export default function LiveMatches() {
  const liveMatches = matches.filter((m) => m.status === 'live');

  if (liveMatches.length === 0) return null;

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-primary-500 animate-pulse"></span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              正在直播
            </h2>
          </div>
          <span className="px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
            {liveMatches.length}场
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {liveMatches.map((match) => (
            <div
              key={match.id}
              className="group p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-200"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-medium text-foreground-500">{match.league}</span>
                <div className="flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
                  <span className="text-xs font-semibold text-accent-600">{match.time}</span>
                </div>
              </div>

              <div className="flex items-center justify-between gap-3 mb-3">
                <div className="flex flex-col items-center gap-2 flex-1">
                  <img
                    src={match.homeLogo}
                    alt={match.homeTeam}
                    className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover border-2 border-background-200"
                    loading="lazy"
                  />
                  <span className="text-xs md:text-sm font-medium text-foreground-800 text-center whitespace-nowrap">{match.homeTeam}</span>
                </div>

                <div className="flex items-center gap-1.5">
                  <span className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">{match.homeScore}</span>
                  <span className="text-lg text-foreground-400 font-heading">:</span>
                  <span className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">{match.awayScore}</span>
                </div>

                <div className="flex flex-col items-center gap-2 flex-1">
                  <img
                    src={match.awayLogo}
                    alt={match.awayTeam}
                    className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover border-2 border-background-200"
                    loading="lazy"
                  />
                  <span className="text-xs md:text-sm font-medium text-foreground-800 text-center whitespace-nowrap">{match.awayTeam}</span>
                </div>
              </div>

              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span>{match.viewers.toLocaleString()} 人观看</span>
                <span className="text-primary-600 font-medium whitespace-nowrap">进入直播间 <i className="ri-arrow-right-line"></i></span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}